export default __webpack_public_path__ + "media/images/theme/wordmark_light-80345575883e9f7455036fbc6e0e195f.png";